
export const isSelTouchingLastBlock = (value) => {
  const { isExpanded, blocks, endOffset } = value;
  if (!isExpanded) {
    return false;
  }

  if (blocks.size < 2) {
    return false;
  }

  if (endOffset !== 0) {
    return false;
  }

  return true;
};



// WEBPACK FOOTER //
// ./src/components/slate/utils/isSelTouchingLastBlock.js